import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../types/enums";
import { HEADER_HEIGHT } from "../../utils/constants";

export const DemoBlock = ({
  isDemo,
  paddingRight,
}: {
  isDemo: boolean;
  paddingRight?: string;
}) => {
  return (
    <Stack
      width="100%"
      bgcolor="#2194D2"
      alignItems="center"
      justifyContent="center"
      padding="8px 0"
      position="sticky"
      top={HEADER_HEIGHT}
      zIndex={100}
      sx={{ paddingRight }}
    >
      {isDemo ? (
        <Typography variant="body1" color="#FFFFFF" fontWeight={500}>
          You are currently using the demo campaign.{" "}
          <Link to={AppRoutes.CREATE_CAMPAIGN} style={{ color: "#FFFFFF" }}>
            Start new campaign
          </Link>
        </Typography>
      ) : (
        <Typography variant="body1" color="#FFFFFF" fontWeight={500}>
          You have view-only access in this campaign.
        </Typography>
      )}
    </Stack>
  );
};
